import { css } from 'emotion';

import { colors } from '@cobliteam/base-components/src/styles/colors';
import { fonts } from '@cobliteam/base-components/src/styles/fonts';

const divider = css`
  font-size: ${fonts.size.smallest};
  color: ${colors.gray.dark};
`;

export default {
  divider,
};
